var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E9E9EA",
  d: "M8 14.673A6.667 6.667 0 1 0 8 1.34a6.667 6.667 0 0 0 0 13.333",
  opacity: 0.4
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E9E9EA",
  d: "M8 4.627a2.5 2.5 0 0 0-2.5 2.5C5.5 8.48 6.56 9.58 7.967 9.62h.12A2.495 2.495 0 0 0 10.5 7.127a2.5 2.5 0 0 0-2.5-2.5M12.52 12.907A6.65 6.65 0 0 1 8 14.673a6.65 6.65 0 0 1-4.52-1.766c.16-.607.593-1.16 1.227-1.587 1.82-1.213 4.78-1.213 6.586 0 .64.427 1.067.98 1.227 1.587"
})));
export { SvgUser as ReactComponent };